import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableContractPreview = Loadable({
  loader: function loader() {
    return import('../ContractPreview.jsx');
  },
  loading: ComponentLoading
});
export default LoadableContractPreview;